
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M15.255 8.593a6.192 6.192 0 00-6.081 6.084 5.93 5.93 0 003.702 5.594c.028.01.057.016.087.016h1.355a.238.238 0 00.238-.237v-3.116a.24.24 0 00-.07-.168l-1.598-1.596a.702.702 0 01.992-.989l1.207 1.207a.237.237 0 00.337 0l1.206-1.207a.702.702 0 01.993.993l-1.596 1.596a.24.24 0 00-.07.168v3.115c0 .132.106.238.237.238h1.356c.03 0 .059-.005.086-.016a5.93 5.93 0 003.7-5.594 6.192 6.192 0 00-6.08-6.088zM14.32 4.935v1.786a.935.935 0 001.87 0V4.935a.935.935 0 00-1.87 0zM7.107 13.27H4.963a.935.935 0 100 1.872h2.144a.935.935 0 000-1.871zM9.832 8.399L8.049 6.613a.935.935 0 00-1.322 1.323l1.786 1.786a.935.935 0 001.319-1.323zM25.547 13.27h-2.144a.935.935 0 000 1.872h2.144a.935.935 0 000-1.871zM23.784 6.613a.935.935 0 00-1.323 0L20.68 8.399a.935.935 0 101.323 1.323l1.786-1.786a.935.935 0 00-.004-1.323zM17.594 21.448h-4.678a.935.935 0 000 1.871h4.678a.935.935 0 000-1.87zM17.594 24.03h-4.678a.935.935 0 000 1.87h1.19c.113 0 .21.08.233.19a.935.935 0 001.833 0c.022-.11.12-.19.233-.19h1.19a.935.935 0 100-1.87z"}})])])
          )
        }
      }
    